<app-lista-dados
  [upTitulo]="'Feriados do Ponto Eletrônico'"
  [upIcone]="'event_busy'"
  [upCor]="'C62828'"
  [upDados]="feriados"
  [upColunas]="colunasListaDados"
  [upCarregando]="!!subscription"
  [upHabilitaEditarLinha]="true"
  [upLargura]="2"
  [upHabilitaContador]="true"
  [upHabilitaFiltroRapido]="true"
  (ueSalvarLinha)="onSalvarLinha($event)"
  (ueBotaoExcluir)="onDelete($event)">
</app-lista-dados>
